import * as React from 'react';

import {ReactionBar} from 'shells/timeline/reaction-bar/reaction-bar';
import type {Reactions} from 'shells/timeline/reaction-bar/types';

import type {ReactionType} from 'nutshell-graphql-types';

import styles from './timeline-reaction-bar.module.css';

type Props = {
    reactions: Reactions;
    currentUserId: string;
    onToggleReaction: (reactionType: ReactionType) => any;
};

export function TimelineReactionBar(props: Props) {
    const {reactions, onToggleReaction, currentUserId} = props;

    return Object.keys(reactions).length ? (
        <div className={styles['reaction-bar-container']}>
            <ReactionBar
                reactions={reactions}
                currentUserId={currentUserId}
                onToggleReaction={onToggleReaction}
            />
        </div>
    ) : null;
}
